import {Component, OnInit, input} from '@angular/core';
import {ChartConfiguration} from 'chart.js';
import {DailyFootfallPrediction} from '../../../classes/models/prediction/DailyFootfallPrediction';
import {BarChartOptions} from '../../../util/BarChartOptions';
import {SHARED_IMPORTS} from "../../../shared/standalone-imports";

/**
 * This component displays footfall prediction bar chart for one day.
 */
@Component({
  selector: 'app-footfall-week-chart',
  templateUrl: './footfall-week-chart.component.html',
  styleUrls: ['./footfall-week-chart.component.less'],
  imports: [SHARED_IMPORTS]
})
export class FootfallWeekChartComponent implements OnInit {
  /** Hourly footfall prediction for a selected date. */
  readonly dailyPrediction = input<DailyFootfallPrediction>(undefined);

  /** Sets up bar chart options. */
  chartOptions: ChartConfiguration['options'];
  /** Labels of a bar chart. */
  chartLabels: ChartConfiguration<'bar'>['data']['labels'] = [];
  /** The data, which is displayed in the chart (colors and footfall prediction data) */
  chartData: ChartConfiguration<'bar'>['data']['datasets'] = [];
  private graphScale = 1.12;

  /**
   * Sets up a bar chart on page initialization.
   */
  ngOnInit(): void {
    this.chartOptions = BarChartOptions.getChartOptions();
    this.chartLabels = this.dailyPrediction().hourlyPredictions.map(hourlyPrediction => hourlyPrediction.hour + ':00');
    this.chartData = [{
      label: '',
      backgroundColor: '#5c2483',
      borderColor: '#5c2483',
      hoverBackgroundColor: '#b2007c',
      hoverBorderColor: '#b2007c',
      borderWidth: 1,
      data: this.dailyPrediction().hourlyPredictions.map(hourlyPrediction => Math.ceil(hourlyPrediction.prediction))
    }];
    this.chartOptions.scales.y.max = this.dailyPrediction().findHighestFootfall() * this.graphScale;
  }
}
